export default "__VITE_ASSET__BKFwTrLx__"